import { light } from '@eva-design/eva';
import { colors } from './colors';

export const myTheme = {
	...light,

	'color-primary-100': '#E3EBF5',
	'color-primary-200': '#C8D7EC',
	'color-primary-300': '#9AABC6',
	'color-primary-400': '#66748E',
	'color-primary-500': colors.primary,
	'color-primary-600': '#1E2639',
	'color-primary-700': '#151C30',
	'color-primary-800': '#0D1326',
	'color-primary-900': '#080C20',
	'color-success-100': '#D1F8CF',
	'color-success-200': '#A1F2A4',
	'color-success-300': '#6DD97B',
	'color-success-400': '#43B45E',
	'color-success-500': '#16823A',
	'color-success-600': '#106F39',
	'color-success-700': '#0B5D36',
	'color-success-800': '#074B32',
	'color-success-900': '#043E2E',
	'color-info-100': '#DFFAF6',
	'color-info-200': '#C1F6F3',
	'color-info-300': '#9BE5E5',
	'color-info-400': '#7AC5CC',
	'color-info-500': colors.secondary,
	'color-info-600': '#397D93',
	'color-info-700': '#27607B',
	'color-info-800': '#194663',
	'color-info-900': '#0F3252',
	'color-warning-100': '#FCF0C9',
	'color-warning-200': '#F9DD95',
	'color-warning-300': '#EDC05F',
	'color-warning-400': '#DBA037',
	'color-warning-500': '#C47601',
	'color-warning-600': '#A85E00',
	'color-warning-700': '#8D4900',
	'color-warning-800': '#713600',
	'color-warning-900': '#5E2900',
	'color-danger-100': '#FDE7DC',
	'color-danger-200': '#FCCBBA',
	'color-danger-300': '#F8A697',
	'color-danger-400': '#F2847B',
	'color-danger-500': colors.accent,
	'color-danger-600': '#C93B49',
	'color-danger-700': '#A82840',
	'color-danger-800': '#871938',
	'color-danger-900': '#700F32',
	'color-hint-500': colors.hint,
	'color-basic-default': colors.neutral,
	'color-primary-transparent-default': colors.transparent,
	'color-primary-transparent-hover': colors.neutral,
	'color-primary-transparent-focus': colors.neutral,
} as const;
